var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SrListItem',{ref:"toggle",on:{"click":_vm.emitToggle}},[_c('SrListItemAction',{staticClass:"mr-4"},[_c('SrCheckbox',{attrs:{"value":_vm.allItemsSelected}})],1),_c('SrListItemContent',[_c('SrListItemTitle',[_vm._v(_vm._s(_vm.toggleButtonText))])],1)],1),_c('VDivider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }